import React from 'react';
import Hero from './Hero';
import Details from './Details';
import Activities from './Activities';
import GiftInfo from './GiftInfo';

// This component holds the main invitation page content
const Home = ({ partyDetails }) => {
  return (
    <>
      <Hero name={partyDetails.childsName} age={partyDetails.age} />
      <main>
        <Details details={partyDetails} />
        <Activities />
        <GiftInfo />
      </main>
    </>
  );
};

export default Home;
